import { useEffect } from "react";
import Navbar from "./components/Navbar";
import HeroBanner from "./components/HeroBanner";
import SupplierSection from "./components/SupplierSection";
import InfluencerSection from "./components/InfluencerSection";
import EducationSection from "./components/EducationSection";
import USAWarehouseSection from "./components/USAWarehouseSection";
import CanadaWarehouseSection from "./components/CanadaWarehouseSection";
import CommunicationStrip from "./components/CommunicationStrip";
import AllProductsSection from "./components/AllProductsSection";
import USAMadeBanner from "./components/USAMadeBanner";
import CanadaDirectSection from "./components/CanadaDirectSection";
import BuyerQuoteSection from "./components/BuyerQuoteSection";
import OverseasWarehouseSection from "./components/OverseasWarehouseSection";
import CanadaOverseasWarehouseSection from "./components/CanadaOverseasWarehouseSection";
import WholesaleSection from "./components/WholesaleSection";
import CanadaWholesaleSection from "./components/CanadaWholesaleSection";
import Footer from "./components/Footer";

const HomePage = () => {
  useEffect(() => {
    // Dynamic title & meta description
    document.title = "Crown Prime Mall – USA & Canada Factory Wholesale Marketplace";
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute("content", "Crown Prime Mall connects buyers with verified USA and Canada factory suppliers. Shop bulk wholesale products, earn reseller commissions on TikTok, Douyin, Instagram, YouTube and WeChat. Min. $6,000 wholesale orders.");
    }

    const siteUrl = import.meta.env.VITE_SITE_URL || "https://example.com";

    // WebSite schema
    const scriptWebsite = document.createElement("script");
    scriptWebsite.type = "application/ld+json";
    scriptWebsite.id = "schema-home";
    scriptWebsite.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Crown Prime Mall",
      "url": siteUrl,
      "description": "Crown Prime Mall connects buyers with verified USA and Canada factory suppliers. Shop bulk wholesale products, earn reseller commissions on TikTok, Douyin, Instagram, YouTube and WeChat.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": siteUrl + "/products?search={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      }
    });
    if (!document.getElementById("schema-home")) {
      document.head.appendChild(scriptWebsite);
    }

    // Organization schema with sameAs social links
    const scriptOrg = document.createElement("script");
    scriptOrg.type = "application/ld+json";
    scriptOrg.id = "schema-org";
    scriptOrg.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Crown Prime Mall",
      "url": siteUrl,
      "logo": {
        "@type": "ImageObject",
        "url": "https://static.readdy.ai/image/3fc89005e5f8f541d0781d07714068dd/b31ed3570265bb91107b593ba40da4ad.jpeg"
      },
      "description": "Crown Prime Mall is North America's premier B2B factory wholesale marketplace connecting verified USA and Canada factory suppliers with buyers, resellers, and influencers.",
      "areaServed": ["US", "CA"],
      "sameAs": [
        "https://www.tiktok.com/@crownprimemall",
        "https://www.instagram.com/crownprimemall",
        "https://www.youtube.com/@crownprimemall"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer support",
        "availableLanguage": ["English", "Chinese"]
      }
    });
    if (!document.getElementById("schema-org")) {
      document.head.appendChild(scriptOrg);
    }

    return () => {
      const el1 = document.getElementById("schema-home");
      if (el1) el1.remove();
      const el2 = document.getElementById("schema-org");
      if (el2) el2.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroBanner />
        <USAMadeBanner />
        <AllProductsSection />
        <CanadaDirectSection />
        <SupplierSection />
        <InfluencerSection />
        <EducationSection />
        <OverseasWarehouseSection />
        <CanadaOverseasWarehouseSection />
        <WholesaleSection />
        <CanadaWholesaleSection />
        <USAWarehouseSection />
        <CanadaWarehouseSection />
        <BuyerQuoteSection />
        <CommunicationStrip />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
